import { path, pathOr } from "ramda";
export const open = pathOr(false, ["dialog", "open"]);
export const getDialog = path(["dialog"]);
